import { useState } from "react";
import { format, isValid, parse } from "date-fns";
import { CalendarIcon } from "lucide-react";
import ReactInputMask from "react-input-mask";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { MessageError } from "../../message-error";

type Props = {
  id: string;
  name: string;
  value: string;
  onChange: (event: { target: { name: string; value: string } }) => void;
  onBlur: React.FocusEventHandler<HTMLInputElement>;
  isInvalid?: boolean;
  isValid?: boolean;
  messageError?: string;
};

export function BookingDatePicker({ id, name, value, onChange, onBlur, isInvalid, messageError }: Props) {
  const [open, setOpen] = useState(false);
  const parsed = parse(value, "dd/MM/yyyy", new Date());
  const selected = isValid(parsed) ? parsed : undefined;

  return (
    <div className="space-y-1">
      <Popover open={open} onOpenChange={setOpen}>
        <div className="relative">
          <ReactInputMask
            id={id} name={name} mask="99/99/9999" value={value}
            onChange={onChange} onBlur={onBlur} placeholder="dd/mm/aaaa"
            aria-invalid={isInvalid || undefined}
            aria-describedby={isInvalid ? id + "-error" : undefined}
            className="h-10 w-full rounded-md border border-input bg-background py-2 pl-4 pr-12 text-base focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand md:text-sm"
          />
          <PopoverTrigger asChild>
            <Button type="button" variant="ghost" size="icon" className="absolute right-0 top-0" aria-label="Abrir calendário de agendamento">
              <CalendarIcon className="size-4" />
            </Button>
          </PopoverTrigger>
        </div>
        <PopoverContent align="start" className="w-auto p-0" aria-label="Escolher data do agendamento">
          <Calendar mode="single" selected={selected} defaultMonth={selected} autoFocus
            onSelect={(date) => {
              if (!date) return;
              onChange({ target: { name, value: format(date, "dd/MM/yyyy") } });
              setOpen(false);
            }}
          />
        </PopoverContent>
      </Popover>
      <div id={id + "-error"}><MessageError isInvalid={isInvalid} messageError={messageError} /></div>
    </div>
  );
}
